import { ENV } from "../../Utils/constants";
import { cabecerasApi } from "./cabeceras";

export class ReviResultsApi {
  constructor() {
    this.baseApi = ENV.BASE_API;
  }

  async getPatientResultsForTherapist(
    token,
    patientId,
    { page = 1, limit = 10, type } = {},
  ) {
    const q = new URLSearchParams({ page, limit });
    if (type) q.append("type", type);

    const url = `${this.baseApi}/revi/therapist/patient/${patientId}/results?${q.toString()}`;
    return this.#fetch(url, {
      method: "GET",
      headers: cabecerasApi(token),
    });
  }

  async getResultDetailForTherapist(token, resultId) {
    const url = `${this.baseApi}/revi/therapist/result/${resultId}`;
    return this.#fetch(url, {
      method: "GET",
      headers: cabecerasApi(token),
    });
  }

  async #fetch(url, params) {
    const res = await fetch(url, params);
    const json = await res.json().catch(() => ({}));
    if (res.status >= 200 && res.status < 300) return json;
    throw json;
  }
}
